import React,{useRef, useState} from "react";
import Banner from "./Banner/Banner";
import Vison from "./Vison/Vison";
import LearnAbout from "./LearnAbout/LearnAbout";
import ProjectsRaised from "./ProjectsRaised/ProjectsRaised";
import RecentDAO from "./RecentDAO/RecentDAO";
import NavLayout from "../../GlobalComponents/NavLayout/NavLayout";
import { common, publicNav } from "../../utils/navItems";
import Faq from "../../GlobalComponents/Faq/Faq";
import WhatInvetors from "./WhatInvetors/WhatInvetors";
import Footer from "../../GlobalComponents/Footer/Footer";
import ConnectButton from "../../GlobalComponents/ConnectButton/ConnectButton";

const OnBoarding = () => {
  const connectwalletRef = useRef(null);
  const [address, setAddress] = useState("");
  return (
    <div>
      <NavLayout
        bold={true}
        parentRef={connectwalletRef}
        setAddress={setAddress}
        navItems={publicNav}
        buttons={
          <div className="button-container xl:gap-[66px] flex-wrap justify-center">
            <button className=" w-[120px] h-10 border font-normal text-res-xs leading-[19px] border-solid border-main-green">
              <span>R34P</span>
              <span className="font-black"> $36.65</span>
            </button>
            <ConnectButton></ConnectButton>
          </div>
        }
      ></NavLayout>
      <Banner parentRef={connectwalletRef}></Banner>
      <Vison></Vison>
      <LearnAbout></LearnAbout>
      <ProjectsRaised></ProjectsRaised>
      <RecentDAO></RecentDAO>

      <div className=" mb-[200px]">
        <WhatInvetors></WhatInvetors>
        <Faq></Faq>
      </div>
      <Footer></Footer>
    </div>
  );
};

export default OnBoarding;
